<template>
    <b-modal v-model="showModal" size="xl" button-size="md" hide-footer @hidden="cancelar" :title="prefix + title">
        <ItensAlmoxarifadoList :apenasSaldoPositivo="apenasSaldoPositivo" :prefix="prefix + title"
            @onSelectItem="selecionarItem" />
        <b-form-row class="mt-2">
            <b-col cols="6"></b-col>
            <b-button id="cancelarModalAlmoxarifado" pill style="height: 30px" @click="cancelar" size="sm"
                variant="danger">
                <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                </div>
                <b-tooltip target="cancelarModalAlmoxarifado" title="Cancelar"></b-tooltip>
            </b-button>
        </b-form-row>
    </b-modal>
</template>

<script>

import ItensAlmoxarifadoList from "@/modules/almoxarifados/itens-almoxarifado/ItensAlmoxarifadoList.vue";

export default {
    name: "ModalPageAlmoxarifadoItemBemConsumo",
    components: { ItensAlmoxarifadoList },
    props: {
        apenasSaldoPositivo: {
            type: Boolean,
            default: false,
        },

        prefix: { type: String, default: "" },
        title: { type: String, default: "Itens do Almoxarifado" }
    },
    data() {
        return {
            showModal: true
        };
    },
    methods: {
        selecionarItem(item) {
            this.showModal = false;
            this.$emit("onselect", item);
        },
        cancelar() {
            this.showModal = false;
            this.$emit("fecharModal");
        }
    }
};
</script>
